import type { Source } from '@mg/shared';

/**
 * Whether the signed-in user added this source. Only they see Pull now, Edit and Delete on its row;
 * the API refuses the same three to anyone else, so this decides what to offer, not what is allowed.
 */
export function isOwnSource(source: Pick<Source, 'ownerUserId'>, userId: string | undefined): boolean {
  return userId !== undefined && source.ownerUserId === userId;
}

/** What the Delete source modal asks to be typed before it enables the button. */
export const DELETE_CONFIRMATION_WORD = 'delete';

/** The Delete source button unlocks on "delete" — trimmed, in any case. */
export function isDeleteConfirmed(typed: string): boolean {
  return typed.trim().toLowerCase() === DELETE_CONFIRMATION_WORD;
}
